import {Component, DoCheck, Input, OnInit} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExgModalService} from 'exc-controls-v2';
import {ApplicationService} from '../../services/application.service';
import {EnumerationService} from '../../services/enumeration.service';

@Component({
  selector: 'app-modal-formular-version',
  templateUrl: './modal-formular-version.component.html',
  styles: [
  ]
})
export class ModalFormularVersionComponent extends ExcTranslation implements OnInit, DoCheck {
  @Input() data: any;

  dataModel: any = {
    frmVName: '',
    frmVDescription: '',
    frmV_enmIdent_FormularVersionStatus: 2
  };
  dataModelClone: any;
  isNew = true;
  isDisabled = false;

  constructor(
    private modalSvc: ExgModalService,
    private appSvc: ApplicationService,
    public enumSvc: EnumerationService,
  ) {
    super();
  }

  ngOnInit(): void {

    if (!this.data || this.data.isNew) {
      this.dataModelClone = this.appSvc.helperObj.clone(this.dataModel);
      this.isNew = true;
    } else {
      this.dataModelClone = this.appSvc.helperObj.clone(this.data);
      this.dataModel = this.appSvc.helperObj.clone(this.data);
      this.isNew = false;
    }
  }

  ngDoCheck(): void {
    if (this.appSvc.helperObj.changed(this.dataModel, this.dataModelClone)) {
      if (this.dataModelClone.frmVName && this.dataModelClone.frmVName.length > 0) {
        this.isDisabled = false;
      }
    } else {
      this.isDisabled = true;
    }
  }

  delete(): void {
    if (this.dataModelClone.frmVID) {
      this.modalSvc.action({
        del: true
      });
    }
  }

  cancel(): void {
    this.close();
  }

  close(): void {
    this.modalSvc.close();
  }

  save(): void {
    if (this.isNew || this.appSvc.helperObj.changed(this.dataModel, this.dataModelClone)) {
      if (!this.isDisabled) {
        this.modalSvc.action(this.dataModelClone);
      }
    }
  }

  changeStateEnum($event: any): void {
    this.dataModelClone.frmV_enmIdent_FormularVersionStatus = $event;
  }
}
